<div id="app" role="main">
    @if (currentUser) {
        <app-sidebar></app-sidebar>
    }

    <div id="layout" [ngClass]="isSidebarCollapsed ? 'collapsed-sidebar' : 'expanded-sidebar'">
        @if (currentUser) {
            <div id="header-container">
                <app-header></app-header>
                <div id="breadcrumbs-container">
                    <app-breadcrumbs></app-breadcrumbs>
                </div>
            </div>
        }

        @if (!isUserLoading && !isActiveGroupLoading) {
            <main id="content">
                @if (!hasError) {
                    <router-outlet></router-outlet>
                }
                @if (hasError && currentUser) {
                    <app-error-page></app-error-page>
                }
                @if (hasError && !currentUser) {
                    <app-unauthorized-page></app-unauthorized-page>
                }
                <footer id="app-footer">
                    <app-footer></app-footer>
                </footer>
            </main>
        }

        @if (isUserLoading || isActiveGroupLoading) {
            <div id="app-loader">
                <app-loader [globalLoader]="true"></app-loader>
            </div>
        }

        @if (currentUser && window.innerWidth < 990) {
            <div id="mobile-footer">
                <app-mobile-menu></app-mobile-menu>
            </div>
        }
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>

@if (currentUser) {
    <app-delete-draft-modal></app-delete-draft-modal>
}
<app-announcement-modal />
